import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";

import { programApiClient } from "@/libs/api";

export const Route = createFileRoute("/_authenticated/org/$orgId/program/$programId")({
  component: () => <Outlet />,
  beforeLoad: async ({ params }) => {
    const program = await programApiClient.getOne(params.programId);
    if (!program) throw notFound();
    return { program };
  },
  notFoundComponent: () => (
    <div className="flex items-center justify-center p-12">Chương trình không tồn tại</div>
  )
});
